import Dashboard from "views/Dashboard.js";
import UserProfile from "views/UserProfile.js";
import TableList from "views/TableList.js";
import skillMaster from "views/skillMaster";
// import Typography from "views/Typography.js";
import Icons from "views/Icons.js";
// import Maps from "views/Maps.js";
import Freelancer from "views/Freelancer.js";
import Employers from "views/Employers";
import GeneralSetting from "views/GeneralSetting";
import Finance from "views/Finance";
import SiteManagement from "views/SiteManagement";
import Report from "views/Report";
import Support from "views/Support";
import Settings from "views/Settings";
import QuestionBank from "views/QuestionBank";
import Jobs from "views/Jobs";
import Projects from "views/Projects";
import SkillTest from "views/SkillTest";
import Verification from "views/Verification";
import Testimonial from "views/Testimonial";
import GuideDigilanxer from "views/GuideDigilanxer";
import Newsletter from "views/Newsletter";
import PartnerWithUs from "views/PartnerWithUs";
import DisplayPartnerWithUs from "views/DisplayPartnerWithUs";
import DisplayProduct from "views/DisplayProduct";
import Bids from "views/Bids";
import DisplayDispute from "views/DisplayDispute";
import ListDegree from "views/ListDegree";
import CertificatePayment from "views/CertificatePayment";
import Changepassword from "views/Changepassword";
const dashboardRoutes = [

  {
    id: 1,
    path: "/dashboard",
    name: "Dashboard",
    icon: "nc-icon nc-chart-pie-35",
    component: Dashboard,
    layout: "/admin",
    accordian: false,
  }, 
 
  {
    id: 3,
    path: "/Freelancers",
    name: "Freelancers",
    icon: "nc-icon nc-bell-55",
    component: Freelancer,
    layout: "/admin",
    accordian: false,  
  },
  {
    id: 4,
    path: "/Employers",
    name: "Employers",
    icon: "nc-icon nc-bell-55",
    component: Employers,
    layout: "/admin",
    accordian: false,
  }, 
  {
    id: 5,
    path: "/jobs",
    name: "Jobs",
    icon: "nc-icon nc-atom",
    component: Jobs,
    layout: "/admin",
    accordian: false,
  },
  {
    id: 6,
    path: "/projects",
    name: "Projects",
    icon: "nc-icon nc-atom",
    component: Projects,
    layout: "/admin",
    accordian: false,
  },
  {
    id: 7,
    path: "/SkillTests",
    name: "Certification",
    icon: "nc-icon nc-atom",
    component: SkillTest,
    layout: "/admin",
    accordian: false,
  },
  {
    id: 8,
    path: "/QuestionBank",
    name: "QuestionBank",
    icon: "nc-icon nc-atom",
    component: QuestionBank,
    layout: "/admin",
    accordian: false,
  },
  {
    id: 9,
    path: "/Finance",
    name: "Finance",
    icon: "nc-icon nc-bell-55",
    component: Finance,
    layout: "/admin",
    accordian: false,    
  },
  {
    id: 10,
    path: "/Reviews",
    name: "Reviews",
    icon: "nc-icon nc-chart-pie-35",
    component: Dashboard,
    layout: "/admin",
    accordian: false,
  },  
  {
    id: 15,
    path: "/Settings",
    name: "Settings",
    icon: "nc-icon nc-chart-pie-35",
    component: Settings,
    layout: "/admin",
    accordian: false,  

  },
  {
    id: 16,
    path: "/Verification",
    name: "verification",
    icon: "nc-icon nc-chart-pie-35",
    component: Verification,
    layout: "/admin",
    accordian: false,

  },
  {
    id: 17,
    path: "/Testimonial",
    name: "testimonial",
    icon: "nc-icon nc-chart-pie-35",
    component: Testimonial,
    layout: "/admin",
    accordian: false,

  },
  {
    id: 18,
    path: "/guidDigilanxer",
    name: "guide Digilanxer",
    icon: "nc-icon nc-chart-pie-35",
    component: GuideDigilanxer,
    layout: "/admin",
    accordian: false,
  },
  {
    id: 18,
    path: "/newsletter",
    name: "newsletter",
    icon: "nc-icon nc-chart-pie-35",
    component: Newsletter,
    layout: "/admin",
    accordian: false,
  },
  {
    id: 19,
    path: "/Product",
    name: "Product",
    icon: "nc-icon nc-chart-pie-35",
    component: DisplayProduct,
    layout: "/admin",
    accordian: false,
  },
  {
    id: 20,
    path: "/PartnerWithUs",
    name: "Partner With US",
    icon: "nc-icon nc-chart-pie-35",
    component: DisplayPartnerWithUs,
    layout: "/admin",
    accordian: false,
  },
  {
    id: 21,
    path: "/Dispute",
    name: "Dispute",
    icon: "nc-icon nc-chart-pie-35",
    component: DisplayDispute,
    layout: "/admin",
    accordian: false,
  },
   {
    id: 22,
    path: "/ListDegree",
    name: "ListDegree",
    icon: "nc-icon nc-chart-pie-35",
    component: ListDegree,
    layout: "/admin",
    accordian: false,
  }, 
  {
    id: 23,
    path: "/certificate-payment",
    name: "Certificate Payment",
    icon: "nc-icon nc-credit-card",
    component: CertificatePayment,
    layout: "/admin",
    accordian: false,
  }, 
  {
    id: 24,
    path: "/change-password",
    name: "Change Password",
    icon: "nc-icon nc-key-25",
    component: Changepassword,
    layout: "/admin",
    accordian: false,
  },  
  
];

export default dashboardRoutes;
